import apiFetch from '@wordpress/api-fetch';
import { toast } from 'sonner';
import { useConditional } from '../state/storeConditional ';
import { useGetTimeTableYear } from './useGetTimeTableYear';
import { UseEndPoints } from './api/endpoints';

export const usePostTimeTable = () => {
	const {updateIsReadyGenerator, updateIsReadyToPost } = useConditional();

const {reFreshTimeTableYear} = useGetTimeTableYear();
	const appendDataPost = ( timetable ) => {
		  const endpoint = UseEndPoints();
		
		apiFetch( {
			path: endpoint + '/fp_prayertimetable',
			method: 'POST',

			data: timetable,
			// ..other data, if any..
		} )
			.then( ( post ) => {
				// console.log( '❤ TimeTable', post );
				toast.success( ` generate new data 😁` );

				// reFreshTimeTable();
				// reFreshTimeTableYear();
				// GenerateClick( 'yes' );
				reFreshTimeTableYear();
				updateIsReadyGenerator( false );
				updateIsReadyToPost( false );
			} )
			.catch( ( err ) => console.log( '💋', err ) );
	};

	return { appendDataPost };
};
